

import type {
    TCoreSupportedDateFilterOperators,
    TCoreSupportedOperators,
} from "@buzzwaretech/types";
import {
    CORE_COLLECTION_OPERATOR,
    CORE_COMPARISON_OPERATOR,
    CORE_EQUALITY_OPERATOR,
} from "@buzzwaretech/types";

/**
 * Core operator labels
 */
export const CORE_OPERATOR_LABELS_MAP: Record<TCoreSupportedOperators, string> =
  {
    [CORE_EQUALITY_OPERATOR.EXACT]: "is",
    [CORE_COLLECTION_OPERATOR.IN]: "is any of",
    [CORE_COMPARISON_OPERATOR.RANGE]: "between",
  } as const;

/**
 * Core date-specific operator labels
 */
export const CORE_DATE_OPERATOR_LABELS_MAP: Record<
  TCoreSupportedDateFilterOperators,
  string
> = {
  [CORE_EQUALITY_OPERATOR.EXACT]: "is",
  [CORE_COMPARISON_OPERATOR.RANGE]: "between",
} as const;
